import { Reducer } from 'redux';
import { RequestItem, RequestStatusData } from 'types';

import { Actions } from 'store/actions/requests.action';
import {
  REQUESTS_ADD,
  REQUESTS_LOADING,
  DOWNLOADING_FILE,
  REQUESTS_ADD_ONE,
  REQUESTS_FAILURE,
  REQUESTS_TOTAL_PAGES,
  REQUEST_DATA,
  REQUEST_UPDATE,
  REQUEST_RESET,
  REQUEST_STATUS_DATA
} from 'store/types/requests.type';

import { RootReducerType } from './index';

export type State = {
  data?: RequestItem[];
  requestData?: any;
  totalPages: number;
  isLoading: boolean;
  error: string;
  updateMessage?: string;
  updateMessageType?: 'error' | 'success';
  requestStatusData?: RequestStatusData;
  downloadings: number[]
};

const initialState: State = {
  data: undefined,
  totalPages: 0,
  requestData: undefined,
  isLoading: false,
  downloadings: [],
  error: '',
};

export const requestsReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTS_ADD:
      return { ...state, data: action.preload, isLoading: false };
    case REQUESTS_TOTAL_PAGES:
      return { ...state, totalPages: action.pageCount, isLoading: false };
    case REQUESTS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case REQUESTS_LOADING:
      return { ...state, isLoading: true, error: '', updateMessage: '', requestStatusData: undefined };
    case REQUESTS_ADD_ONE:
      return { ...state, data: [...(state.data || []), action.item], isLoading: false };
    case REQUEST_DATA:
      return { ...state, isLoading: false, requestData: action.preload }
    case REQUEST_STATUS_DATA:
      return { ...state, isLoading: false, requestStatusData: action.requestStatus }

    case DOWNLOADING_FILE:
      return { ...state, downloadings: action.isDownloading ? state.downloadings.concat(action.rid) : state.downloadings.filter(i => i !== action.rid) };
    case REQUEST_UPDATE:
      return { ...state, updateMessage: action.message, updateMessageType: action.messageType, isLoading: false }
    case REQUEST_RESET:
      return initialState
    default:
      return state;
  }
};

export const requestsSelector = (state: RootReducerType) => state.requests;
export default requestsReducer;
